import formCalendar from '@js/components/form-calendar';

export default {
  init() {
    if ($('#js-calendar').length) {
      formCalendar.create($('#js-calendar'));
    }

    this.events();
  },

  events() {
    $('form.filter').on('submit', (e) => {
      e.preventDefault();

      this.formSubmit();
    });
    $('.filter__clear').on('click', (e) => {
      e.preventDefault();

      window.location = window.location.origin + window.location.pathname;
    });
    // Search.
    $('.form-field__input ').on('keypress', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.formSubmit();
      }
    });
  },

  formSubmit() {
    const params = new URLSearchParams();

    // get search.
    const search = $('.form-field__input[name=search]').val();
    if (search) {
      params.append('search', search);
    }
    // get form type.
    const type = $('.form-field__input[name=type]').val();
    if (type) {
      params.append('type', type);
    }
    // get form status.
    const status = $('.form-field__input[name=status]').val();
    if (status) {
      params.append('status', status);
    }
    // get form status.
    const calendar = $('.form-field__input[name=calendar]').val();
    if (calendar) {
      params.append('date', calendar);
    }

    const url = window.location.origin + window.location.pathname;

    if (params.toString()) {
      window.location = url + '?' + params.toString();
    } else {
      window.location = url;
    }
  },
};
